import Home from './components/Home.svelte';
import About from './components/About.svelte';
import NewSheet from './components/NewSheet.svelte';
import Editor from './components/Editor.svelte';

const routes = {
  '/': Home,
  '/cheatsheet/new': NewSheet,
  '/cheatsheet/:id/edit': Editor,
  '/about': About,
  // TODO implement 404
  // '*': NotFound,
}

export default routes;